export default {
  form: {
    amount: {
      label: 'Preț',
    },
    has_sales_based_discount: {
      label: 'Reduceri bazate pe vânzările lunare',
    },
  },
  labels: {
    month: 'lună',
    varies_by_tier: 'variază în funcție de nivel',
    max_price: '* Prețul maxim este {{amount}}',
    sales_based_discount:
      'până la +{{threshold}} vânzări minime într-o lună. După aceea prețul obișnuit {{amount}} net/lună',
  },
  tax: {
    inclusive: '{{taxName}}: {{tax}} (inclus)',
    exclusive: 'pe lună plus {{taxName}}: {{tax}}',
  },
  buttons: {
    select: 'Selectează',
    save: 'Salvează',
    use_default_price: 'Utilizează prețul implicit',
  },
};
